import styled from "@emotion/styled";
import { Theme } from "@emotion/react";

import { theme } from "../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

import { InfoBlockType } from "./InfoBlockType";

const resolveBgColor = (type: InfoBlockType, props: Theme | { theme: Theme }) => {
    const infoBlockColors = {
        [InfoBlockType.info]: theme(props).semanticColors.action.backgroundColor,
        [InfoBlockType.error]: theme(props).semanticColors.danger.backgroundColor,
        [InfoBlockType.warning]: theme(props).semanticColors.warning.backgroundColor,
        [InfoBlockType.success]: theme(props).semanticColors.success.backgroundColor,
    };

    return infoBlockColors[type];
};

export const InfoBlockWrapper = styled.div<{ type: InfoBlockType }>(props => ({
    display: "flex",
    backgroundColor: resolveBgColor(props.type, props) ?? theme(props).semanticColors.action.backgroundColor,
    padding: "8px",
    borderRadius: "4px",
}));

export const InfoBlockIconWrapper = styled.span({
    marginRight: "4px",
});

export const InfoBlockHeader = styled.div({
    fontWeight: 700,
});
